<template>
  <div v-if="props.showModal" class="modal modal-dl">
    <div class="d-flex justify-content-center align-items-center m-auto h-100">
      <div class="modal-content">
        <!-- Modal header -->
        <div class="modal-header">
          <h4 class="modal-title" style="letter-spacing: 0.5em; padding-left: 0.5em;">{{ props.title }}</h4>
          <a style="position: absolute; right: 10px; top: 10px; cursor: pointer;" @click="closeModal">&#10006;</a>
        </div>

        <!-- Modal body -->
        <div class="modal-body" v-if="$slots.body">
          <slot name="body"></slot>
        </div>

        <!-- Modal footer -->
        <div class="modal-footer" v-if="$slots.footer">
          <slot name="footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              取消
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  showModal: {
    type: Boolean
  },
  title: {
    type: String
  },
  size: {
    type: String
  }
})

const emit = defineEmits(['update:showModal'])
const closeModal = () => {
  emit('update:showModal', false)
}
</script>